import React from "react";
import { connect } from "react-redux";
import { GRAPHQL_TYPE_ENTITY } from "@radivision/graphql";
import { AppState } from "../../../redux";
import { FormFieldContainer, FormFieldInput } from "../../../react-components/modals/modal-form-elements";
import { SetProfileStateAction, SetProfileStatePayload, ProfileModuleState } from "../redux/profile/types";
import { setProfileState } from "../redux/profile/actions";
import { CompanyTypes, companyTypeLabel } from "../../../constants/company-info";

interface MapStateProps {
  activities: string[];
  isCompany: boolean;
}

interface MapDispatchProps {
  setProfileState: (payload: SetProfileStatePayload) => SetProfileStateAction;
}

export type Props = MapDispatchProps & MapStateProps;

export const Component = (props: Props) => {
  const { activities, setProfileState, isCompany } = props;

  if (!isCompany) return null;

  // A company saved under a type that is no longer offered (e.g. "Government
  // agency") would otherwise show the first option, "Public Company", while
  // keeping the old value on save. Show the saved type so the form is honest.
  const CURRENT = activities[0];
  const IS_LEGACY = !!CURRENT && !CompanyTypes.some(({ kind }) => kind === CURRENT);

  return (
    <FormFieldContainer>
      <label htmlFor="activities">
        <span>Company Structure: *</span>
      </label>
      <FormFieldInput>
        <select
          value={activities[0] ? activities[0] : ""}
          onChange={(e) => {
            setProfileState({ activities: [e.target.value] });
          }}
        >
          <option disabled value={""}>
            Select company structure
          </option>
          {IS_LEGACY && <option value={CURRENT}>{companyTypeLabel(CURRENT)}</option>}
          {CompanyTypes.map(({ kind, title }) => {
            return (
              <option key={`company-type-${kind}`} value={kind}>
                {title}
              </option>
            );
          })}
        </select>
      </FormFieldInput>
    </FormFieldContainer>
  );
};

const mapState = (state: AppState & ProfileModuleState) => {
  return {
    activities: state.profile.activities,
    isCompany: state.profile.type === GRAPHQL_TYPE_ENTITY,
  };
};

const mapDispatch = {
  setProfileState: setProfileState,
};

export const CompanyType = connect(mapState, mapDispatch)(Component);
